import { Injectable } from '@angular/core';
import { DialogOptions } from 'ng2-bootstrap-modal';
import { DataService } from '../data.service';
import { FormGroup } from '@angular/forms';

@Injectable({
    providedIn: 'root'
})
export class UtilService {
    constructor(private dataService: DataService) { }


    modalOptions: DialogOptions = {
        backdropColor: 'rgba(0,0,0,0.7)'
    };

    public getUrlEnv(): string {
        if (window.location.host.indexOf('localhost') > -1) {
            return 'http://acp-';
        } else if (window.location.host.indexOf('acp-') > -1) {
            return 'https://acp-';
        } else {
            return 'http://';
        }
    }

    public getOwnerEnv(): string {
        if (window.location.host.indexOf('localhost') > -1) {
            return 'horn';
        } else if (window.location.host.indexOf('acp-') > -1) {
            return 'horn';
        } else {
            return 'ca';
        }
    }

    public getModalOptions() {
        return this.modalOptions;
    }

    public getOrderType(reverse: boolean) {
        return reverse ? 'desc' : 'asc';
    }

    public DownloadFile(endpoint: string, filename: string, body: any) {
        this.dataService.postAny(endpoint, body, { responseType: 'blob' }).subscribe((value) => {
            const name = filename;
            const blob = new Blob([value], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            if ((window.navigator as any).msSaveOrOpenBlob) {
                (window.navigator as any).msSaveOrOpenBlob(blob, name);
            } else {
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = name;
                document.body.appendChild(link);
                link.click();
                setTimeout(() => {
                    window.URL.revokeObjectURL(link.href);
                    document.body.removeChild(link);
                }, 0);
            }
        });
    }

    setFormControl(form: FormGroup, formName: string, value: any) {
        form.controls[formName].setValue(value);
    }

    getFormControl(form: FormGroup, fieldName: string) {
        return form.get(fieldName);
    }

    getCredits() {
        return [
            "A vista",
            "Aprovado",
            "Autorizado",
            "Aut. Confirmar",
            "Cancelado",
            "Consórcio",
            "Em Análise",
            "Não Definido",
            "Negado",
            "Vencida"
          ];
    }
}
